const menu = {
    label: 'Leitura QRCode',
    icon: 'pi pi-fw pi-qrcode',
    rules: ['CHECKINS-EVENTOS-15'],
    to: '/checkins/impressoras/leitura-qrcode',
};

export default menu;
